export const starCount = (count)=>{
    let starArray = []
    for(let i=0;i<count;i++){
        starArray.push(<i className="fa-solid fa-star checked" />)
    }
    return starArray
}